<div class="loren-asset-details-tab-header">
  <h2 class="loren-asset-details-tab-title">
    {{ "asset_details.detailed_info" | transloco }}
  </h2>
  @if (!isHandset) {
  <button matButton="filled" (click)="clearFilters()" class="btn-secondary">
    {{ "asset_details.clear_all_filters" | transloco }}
  </button>
  }
</div>
@if(isHandset) { @for(el of tableElData(); track el) {
<div class="loren-table-mobile">
  <div class="loren-table-mobile-header">
    <span>{{ el.name | transloco }}</span>
    <span>{{ el.description }}</span>
  </div>
  <div class="loren-table-mobile-content">
    <span class="loren-table-mobile-content--key">{{
      "asset_details.value" | transloco
    }}</span>
    <span>
        @if(MeticConfig[el.type]; as config) {
            <ng-container *ngComponentOutlet="
                config.tableComponent;
                inputs: { asset: asset(), metric: getMetric(el.id) }
            " />
        } @else {
            {{ el.value }}
        }
    </span>
    <span class="loren-table-mobile-content--key">{{
      "asset_details.service" | transloco
    }}</span>
    <span>{{ el.service }}</span>
    <span class="loren-table-mobile-content--key">{{
      "asset_details.updated" | transloco
    }}</span>
    <span>{{ el.updated | lorenDate }}</span>
    <span class="loren-table-mobile-content--key">{{
      "asset_details.battery" | transloco
    }}</span>
    <battery-level [deviceId]="el.deviceId" />
  </div>
</div>
} }@else {
<table
  mat-table
  [dataSource]="tableElData()"
  class="loren-asset-details-info-table">
  <ng-container matColumnDef="name">
    <th
      mat-header-cell
      *matHeaderCellDef
      class="loren-asset-details-info-table--header">
      {{ "asset_details.name" | transloco }}
      <mat-icon
        class="loren-asset-details-info-table--header-icon"
        (click)="sort('name')">
        import_export
      </mat-icon>
      <mat-icon
        class="loren-asset-details-info-table--header-icon"
        [matMenuTriggerFor]="nameFilter"
        #menuTrigger
        >filter_alt</mat-icon
      >
    </th>
    <td mat-cell *matCellDef="let element">
        @if(element.kind === kinds.PRESENCE_BEACON) {
            @if(element.image !== null) {
                <img  class="loren-asset-card-header-image" [src]="element.image | lorenImage | async" alt="Asset image" />
            }
        }
      {{ element.name | transloco }}
      @if(element.kind === kinds.TRACKING){
      <mat-icon
        [ngClass]="{
          'loren-metric-location-on': element.hasGPSCovering,
          'loren-metric-location-off': !element.hasGPSCovering
        }"
        [matTooltip]="
          (element.hasGPSCovering
            ? 'dashboard.gps_data_reliable'
            : 'dashboard.gps_data_not_reliable'
          ) | transloco
        "
        >{{ element.hasGPSCovering ? "share_location" : "gps_off" }}</mat-icon
      >
      }

    </td>
  </ng-container>

  <ng-container matColumnDef="description">
    <th
      mat-header-cell
      *matHeaderCellDef
      class="loren-asset-details-info-table--header">
      {{ "asset_details.description" | transloco }}
    </th>
    <td mat-cell *matCellDef="let element">
      {{ element.description || "---" }}
    </td>
  </ng-container>

  <ng-container matColumnDef="value">
    <th
      mat-header-cell
      *matHeaderCellDef
      class="loren-asset-details-info-table--header">
      {{ "asset_details.value" | transloco }}
    </th>
    <td
      mat-cell
      *matCellDef="let element"
      class="loren-asset-details-info-table--value">
        @if(MeticConfig[element.type]; as config) {
            <ng-container *ngComponentOutlet="
                config.tableComponent;
                inputs: { asset: asset(), metric: getMetric(element.id) }
            " />
        } @else {
            {{ element.value }}
        }
    </td>
  </ng-container>

  <ng-container matColumnDef="service">
    <th
      mat-header-cell
      *matHeaderCellDef
      class="loren-asset-details-info-table--header">
      {{ "asset_details.service" | transloco }}
    </th>
    <td mat-cell *matCellDef="let element">{{ element.service }}</td>
  </ng-container>

  <ng-container matColumnDef="updated">
    <th
      mat-header-cell
      *matHeaderCellDef
      class="loren-asset-details-info-table--header">
      {{ "asset_details.updated" | transloco }}
      <mat-icon
        class="loren-asset-details-info-table--header-icon"
        (click)="sort('updated')">
        import_export
      </mat-icon>
      <mat-icon
        class="loren-asset-details-info-table--header-icon"
        [matMenuTriggerFor]="updatedFilter"
        #menuTrigger
        >filter_alt</mat-icon
      >
    </th>
    <td
      mat-cell
      *matCellDef="let element"
      class="loren-asset-details-info-table--date">
      {{ element.updated | lorenDate }}
    </td>
  </ng-container>

  <ng-container matColumnDef="battery">
    <th
      mat-header-cell
      *matHeaderCellDef
      class="loren-asset-details-info-table--header"
      style="text-align: end">
      {{ "asset_details.battery" | transloco }}
    </th>
    <td mat-cell *matCellDef="let element">
      <battery-level [deviceId]="element.deviceId"/>
    </td>
  </ng-container>

  <tr
    mat-header-row
    *matHeaderRowDef="displayedColumns"
    class="loren-asset-details-info-table--header-row"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
</table>
}

<mat-menu #nameFilter="matMenu">
  <ng-template matMenuContent>
    <loren-filters
      [placeholder]="'asset_details.filter_by_metric' | transloco"
      [initiallySelected]="activeFilters().name"
      [items]="nameFilters()"
      [showSearch]="false"
      (selectionSubmitted)="filterName($event)">
    </loren-filters>
  </ng-template>
</mat-menu>
<mat-menu #updatedFilter="matMenu">
  <ng-template matMenuContent>
    <loren-filters
      [initiallySelected]="activeFilters().updated"
      [items]="updatedFilters"
      [placeholder]="'asset_details.filter_by_updated' | transloco"
      [showSearch]="false"
      [withNumber]="1"
      (selectionSubmitted)="filterUpdated($event)">
    </loren-filters>
  </ng-template>
</mat-menu>
